import styled from 'styled-components';
import Typography from '@src/new-components/Typography';
import { COLOR } from '@src/styles/color';

export const StyledSourcesRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
`;

export const StyledSourceIcon = styled.img`
  width: 32px;
  height: 32px;
  border-radius: 8px;
  object-fit: cover;
  flex-shrink: 0;
`;

export const StyledPreviewCard = styled.div`
  width: 100%;
  padding: 16px;
  display: flex;
  gap: 16px;
  align-items: center;
  border: 0.5px solid ${COLOR.indigo[16]};
  border-radius: 12px;
  background: ${COLOR.white};
  box-sizing: border-box;
`;

export const StyledPreviewContent = styled.div`
  flex: 1 1 0;
  min-width: 0;
  display: flex;
  gap: 12px;
  align-items: flex-start;
`;

export const StyledPreviewThumb = styled.img`
  width: 80px;
  height: 48px;
  border-radius: 8px;
  object-fit: cover;
  flex-shrink: 0;
`;

export const StyledPreviewTitle = styled(Typography)`
  flex: 1;
  min-width: 0;
  margin: 0 !important;
  display: -webkit-box !important;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const StyledUrlLoaderWrap = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  flex-shrink: 0;
`;

// Dashed-bordered upload-style box matching Figma node 13002:6907.
// Wraps the URL input + suggested sources row with the same visual treatment
// as the file dropzone so empty states feel consistent across popups.
export const StyledUrlBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  width: 100%;
  min-height: 192px;
  padding: 40px;
  border: 1px dashed ${COLOR.indigo[32]};
  border-radius: 16px;
  background: ${COLOR.charcoalV2[64]};
  backdrop-filter: blur(8px);
  box-sizing: border-box;
`;

export const StyledUrlErrorText = styled.p`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -0.4px;
  color: ${COLOR.functionalRed.default};
  margin: 0;
`;
